<template>
	<div class="top-link-wrap verticalM">
		<img class="verticalM-box" src="/static/images/home_logo_top_3x.png" @click="goHome" />
		<span class="verticalM-box"><a href="tel:400-832-2777">400-832-2777</a></span>
		<span class="verticalM-box">美心·美家·美生活</span>
	</div>
</template>
<script type="text/javascript">
	export default{
		methods:{
			goHome(){
				this.$router.push({
					path: '/main/home'
				})
			}
		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.top-link-wrap{
		height: 0.75rem;
		padding: 0 0.2rem;
		color: #666666;
		background: #FFFFFF;
		font-size: 0;
		>img{
			width: 20%;
		}
		>span{
			display: inline-block;
			width: 40%;
			@include font-dpr(12px);
		}
		a{
			text-align: center;
			padding: 0.075rem 0 0.075rem 0.45rem;
			color: #666666;
			background: url(/static/images/ic_tel_top_3x.png) no-repeat 0 center;
			background-size: 0.35rem;
		}
		>span{
			text-align: right;
		}
	}
</style>


// WEBPACK FOOTER //
// topLink.vue?609a325a